<!-- Spinner -->

<!-- Content -->
@if ((menuSharedFacade.showFullscreen$ | async) === false) {
  <div #sidebarContainer class="sidebar-container"
    >
    <!-- scrollTop: scroll container switches from #sidebarContainer to ::host under certain condition, so handle both cases (alternatively change .scss) -->
    @if ((slideViewerFacade.currentSelectedSlidePage$ | async | scrollTop: sidebarContainer:elRef.nativeElement); as slide) {
      <!-- Title -->
      @if (slide.header) {
        <h1 class="sidebar-header"
          >
          {{ slide.header }}
        </h1>
      }
      <!-- Text -->
      @if (slide.body) {
        <medsurf-text
          [text]="slide.body"
          [isSlideDescription]="true"
          class="mb-4">
        </medsurf-text>
      }
      <!-- Interactive Area / Poi -->
      @if ((slideViewerFacade.currentSelectedSlideImage$ | async); as image) {
        <medsurf-viewer-interactive-area-list></medsurf-viewer-interactive-area-list>
        <medsurf-viewer-poi-list></medsurf-viewer-poi-list>
      }
      <!-- Question -->
      <medsurf-questions></medsurf-questions>
      <!-- Copyright -->
      <medsurf-copyright></medsurf-copyright>
    } @else {
      <div class="d-flex justify-content-center m-2">
        <div class="spinner-border"></div>
      </div>
    }
  </div>
}
